import React from 'react';
import moment from 'moment';
import Avatar from '../Avatar';
import FontAwesomeIcon from '../Icon';
import Button from '../Button';
import TextEditor from '../Editor/Editor';

const NotesRepeater = ({
  onEdit,
  onDelete,
  notes,
  onImageClicked,
  user,
  enableEdit = true,
}: any) => {
  const canShowActions = !(
    user.roles[0].role.name === 'Strata Manager' ||
    user.roles[0].role.name === 'Home Owner' ||
    user.roles[0].role.name === 'Realtor' ||
    user.roles[0].role.name === 'Occupant'
  );

  return (
    <div>
      {notes.map((note, x) => (
        <div key={x} className="notes__note">
          <div className="notes__title">
            {note.appointment && <>[Reminder] </>}
            {note.title}
            {canShowActions && (
              <div className="notes__actions">
                {enableEdit && (
                  <Button
                    color="semantic"
                    onClick={() => onEdit(note)}
                    label={<FontAwesomeIcon glyph="pencil" weight="light" />}
                  />
                )}
                <Button
                  color="semantic"
                  onClick={() => onDelete(note)}
                  label={<FontAwesomeIcon glyph="trash" weight="light" />}
                />
              </div>
            )}
          </div>
          {note.appointment && (
            <div className="notes__appointment">
              <FontAwesomeIcon glyph="calendar" weight="solid" size="medium" />
              {moment(note.appointment.date).format('dddd MM/DD/YYYY')}
            </div>
          )}
          <div className="notes__body">
            <TextEditor
              editorState={note.body}
              readOnly={true}
              onEditorStateChange={null}
            />
          </div>
          <div>
            {note.image && note.image.length > 1 ? (
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => onImageClicked(x, note)}
              >
                {note.image.split('.com/')[1]}
              </div>
            ) : null}
          </div>
          <div className="notes__author">
            <div className="notes__avatar">
              <Avatar size="small" />
            </div>
            <div className="notes__username">
              {note.author.firstName} {note.author.lastName}
            </div>
            <div className="notes__date">
              {moment(note.createdAt).format('MM/DD/YYYY hh:mm A')}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotesRepeater;
